import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@as/cotopaxi';
import { DpeTileStep, } from '@as-react/common-types';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import DpeValidator from '../dpe-validator/DpeValidator';
const DpeTile = ({ isPopup, isAuthenticated, data, digitalPartner, onConfirmationClick, onActiveStepChange, onFormValidationError, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.dpe);
    const [active, setActive] = useState(isAuthenticated ? DpeTileStep.VALIDATION : DpeTileStep.INTRO);
    const [isAuth, setIsAuth] = useState(false);
    useEffect(() => {
        if (isAuthenticated && isAuthenticated !== isAuth) {
            setActive(DpeTileStep.VALIDATION);
            setIsAuth(true);
        }
    }, [isAuthenticated]);
    const setActiveStep = (stepToSet) => {
        if (stepToSet !== active) {
            onActiveStepChange({
                from: active,
                to: stepToSet,
            });
            setActive(stepToSet);
        }
    };
    const handleIntroButtonClick = () => {
        setActiveStep(DpeTileStep.VALIDATION);
    };
    const renderIntro = () => (_jsx(Box, { paddingBlockEnd: "8", paddingInline: { base: '4', md: '8' }, children: isPopup ? (_jsx(TextAlpha, { variant: "bodyS", children: _jsx(HtmlInclude, { htmlFragment: data.introductionMessage }) })) : (_jsxs(_Fragment, { children: [_jsx(TextAlpha, { variant: "bodyS", children: _jsx(HtmlInclude, { htmlFragment: data.shortIntroductionMessage }) }), _jsx(Button, { text: t('dpe.activateNow'), onClick: handleIntroButtonClick })] })) }));
    const renderValidation = () => (_jsxs(_Fragment, { children: [_jsx(Box, { paddingBlockEnd: { base: '4', md: '6' }, paddingInline: { base: '4', md: '8' }, children: _jsx(TextAlpha, { variant: "bodyS", children: _jsx(HtmlInclude, { htmlFragment: data.validationMessage }) }) }), _jsx(Box, { paddingBlockEnd: { base: '4', md: '8' }, paddingInline: { base: '4', md: '8' }, children: _jsx(DpeValidator, { digitalPartner: digitalPartner, onValidationSuccess: () => setActiveStep(DpeTileStep.CONFIRMATION), onValidationError: errorMessage => {
                        onFormValidationError(Object.assign({}, errorMessage));
                    } }) })] }));
    const renderConfirmation = () => (_jsxs(Box, { paddingBlockEnd: { base: '4', md: '8' }, paddingInline: { base: '4', md: '8' }, children: [_jsx(TextAlpha, { variant: "bodyS", children: _jsx(HtmlInclude, { htmlFragment: data.confirmationMessage }) }), isPopup && (_jsx(Box, { paddingBlockStart: "4", children: _jsx(Button, { text: t('dpe.continue'), onClick: onConfirmationClick }) }))] }));
    const renderStep = () => {
        switch (active) {
            case DpeTileStep.INTRO:
                return renderIntro();
            case DpeTileStep.VALIDATION:
                return renderValidation();
            case DpeTileStep.CONFIRMATION:
                return renderConfirmation();
            default:
                return null;
        }
    };
    return renderStep();
};
export default DpeTile;
